export const ROUTER_BASE_NAME = 'MKII';
export const ROUTES_BASE = `/${ROUTER_BASE_NAME}`;

export const LOCATIONS_ROUTE = '/locations';
export const ANALYTICS_ROUTE = '/analytics';
export const TRANSACTIONS_ROUTE = '/myTransactions';

export const PROVIDER_TRANSACTIONS_ROUTE = '/providerTransactions';
export const PROVIDER_LOCATIONS_ROUTE = '/providerLocations';
export const PROVIDER_DASHBOARD_ROUTE = '/providerDashboard';
export const PROVIDER_PROFILE_ROUTE = '/providerProfile';

export const TAB_ROUTES = [LOCATIONS_ROUTE, ANALYTICS_ROUTE, TRANSACTIONS_ROUTE];

export const PREV_PATH_LOCAL_STORAGE_KEY = 'prevPath';
